import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { PatientCharityCareStatus } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { CharityCareSummaryComponent } from '../../../charity-care-summary/charity-care-summary.component'
import { ExpandableCardComponent } from '../../../expandable-card/expandable-card.component'

@Component({
  selector: 'mmx-balance-charity-care-section',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, ExpandableCardComponent, CharityCareSummaryComponent],
  templateUrl: './balance-charity-care-section.component.html',
})
export class BalanceCharityCareSectionComponent {
  @Input() status: PatientCharityCareStatus | null = null
  @Input() timezone: string | null = null
  @Input() visible = false
  @Input() loading = false
  @Input() patientId: string | null = null
}
